import { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { isMobile } from "../helpers/mobile";
import { useTranslation } from "react-i18next";
import { Capacitor } from "@capacitor/core";
import { useAppDispatch } from "../redux-store";
import {
  hideVersionUpdateModal,
  loadNativeVersion,
} from "../ducks/app/native-version";
import { useSelector } from "react-redux";
import { selectShouldShowUpdateModal } from "../ducks/app/native-version/selectors";
import { Browser } from "@capacitor/browser";

const androidPlayStoreUrl =
  "https://play.google.com/store/apps/details?id=dk.doranordic.app";
const iosAppStoreUrl = "https://apps.apple.com/app/dora/id6739544852";

const NativeVersionCheck = () => {
  const { t } = useTranslation("translation");
  const dispatch = useAppDispatch();
  const platform = Capacitor.getPlatform() as "android" | "ios" | "web";
  const storeName = platform === "android" ? "Play Store" : "App Store";
  const storeUrl =
    platform === "android" ? androidPlayStoreUrl : iosAppStoreUrl;

  const shouldShow = useSelector(selectShouldShowUpdateModal);

  useEffect(() => {
    if (!isMobile || platform === "web") {
      return;
    }
    const check = () => dispatch(loadNativeVersion(platform));
    check();
    const interval = setInterval(check, 24 * 60 * 60 * 1000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch, platform]);

  const handleDownload = async () => {
    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url: storeUrl });
    } else {
      window.open(storeUrl, "_blank");
    }
  };

  const onModalClose = () => {
    dispatch(hideVersionUpdateModal());
  };

  return (
    <Dialog
      open={shouldShow}
      aria-labelledby="version-dialog-title"
      aria-describedby="version-dialog-description"
    >
      <DialogTitle id="version-dialog-title">
        {t("nativeUpdateCheck.heading")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="version-dialog-description">
          {t("nativeUpdateCheck.bodyText", { store: storeName })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onModalClose}>{t("Back")}</Button>
        <Button onClick={handleDownload} variant="contained" color="primary">
          {t("nativeUpdateCheck.downloadButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NativeVersionCheck;
